import { Navigate } from 'react-router-dom';
import Dashboard from '../views/dashboard';
import Catalog from '../views/Catalog';
import Sku from '../views/Sku';
import DMDMfgs from '../views/DMDMfgs';
import STMfgs from '../views/STMfgs';
import Root from "../routes/root";
import AddSku from '../views/AddSku';
import ProtectedRoute from '../components/ProtectedRoute';

export default function privateRoutes(){
  return [{
    path: "/",
    element: <ProtectedRoute><Root /></ProtectedRoute>,
    children: [
      {
        index: true,
        element: <Navigate to="dashboard" replace />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "catalog",
        element: <Catalog />,
      },
      {
        path: "sku",
        element: <Sku />,
      },
      {
        path: "dmdmfg",
        element: <DMDMfgs />,
      },
      {
        path: "stmfg",
        element: <STMfgs />,
      },
      {
        path: "addsku",
        element: <AddSku />,
      },
    ]
  }]
};